import React from 'react';
import { useTranslation } from 'react-i18next';

// Veg Icon Component
export const VegIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    {/* White square with green border */}
    <rect x="1" y="1" width="18" height="18" rx="4" fill="white" stroke="#10B981" strokeWidth="3"/>
    {/* Green circle inside */}
    <circle cx="10" cy="10" r="3" fill="#10B981"/>
  </svg>
);

// Non-Veg Icon Component
export const NonVegIcon = ({ className = "w-5 h-5", ...props }) => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 20 20" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    {/* White square with red border */}
    <rect x="1" y="1" width="18" height="18" rx="4" fill="white" stroke="#EF4444" strokeWidth="3"/>
    {/* Red circle inside */}
    <circle cx="10" cy="10" r="3" fill="#EF4444"/>
  </svg>
);

// Combined Veg/Non-Veg Icon Component
export const VegNonVegIcon = ({ is_veg, className = "w-5 h-5", showLabel = false, ...props }) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';
  const IconComponent = is_veg ? VegIcon : NonVegIcon;
  const label = is_veg ? t('common.veg') : t('common.non_veg');
  const labelColor = is_veg ? 'text-green-600' : 'text-red-600';

  return (
    <div className={`flex items-center ${isArabic ? 'space-x-reverse' : ''}`}>
      <IconComponent className={className} {...props} />
      {showLabel && (
        <span className={`${isArabic ? 'mr-2' : 'ml-2'} text-xs font-medium ${labelColor}`}>
          {label}
        </span>
      )}
    </div>
  );
};

export default VegNonVegIcon;
